module.exports = __webpack_public_path__ + "static/media/empty.[p=1].e2717e97.png";